<template>
  <div>
    <div class="molecule-list-resource_row">
      <div class="row__resource">
        <atom-switch
          v-if="policy !== 'view'"
          v-model="row.isEnabled"
        ></atom-switch>
        <label
          class="resource__label"
          :class="{
            'resource__label--disable': row.isEnabled === false,
            basic__resource: policy === 'view',
          }"
          >{{
            row.resource === "Storage" ? "Available Storage" : row.resource
          }}</label
        >
      </div>

      <div
        class="row__container"
        :class="[
          policy === 'view' ? 'row__container--center' : 'row__container--top',
        ]"
      >
        <div class="row__warning">
          <div class="row__sub-container">
            <div class="row__title">{{ column[1].title }}</div>
            <div v-if="policy === 'view'" class="row__label">
              {{ row.warning }}
            </div>
            <atom-input
              v-else
              v-model="row.warning"
              placeholder="Warning"
              :isDisable="!row.isEnabled"
              :isError="isError && isShowError"
            ></atom-input>
          </div>
        </div>
        <div class="row__critical">
          <div class="row__sub-container">
            <div class="row__title">{{ column[2].title }}</div>
            <div v-if="policy === 'view'" class="row__label">
              {{ row.critical }}
            </div>
            <atom-input
              v-else
              v-model="row.critical"
              placeholder="Critical"
              :isDisable="!row.isEnabled"
              :isError="isError && isShowError"
            ></atom-input>
          </div>
        </div>
        <div class="row__unit">
          <div class="row__sub-container">
            <div class="row__title">{{ column[3].title }}</div>
            <div v-if="policy === 'view'" class="row__label">
              {{ row.unit.name }}
            </div>
            <atom-select
              v-else
              class="unit__select"
              :option="unit"
              :isClearable="false"
              placeholder="Unit"
              :isDisable="!row.isEnabled"
              :isError="isError && isShowError"
              v-model="row.unit.name"
              @input="changeSelected($event)"
            ></atom-select>
          </div>
        </div>
      </div>
      <div
        v-if="row.isEnabled && isError && isShowError && policy !== 'view'"
        class="row_error"
      >
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
export default {
  name: "MoleculeItemResource",
  components: { AtomSwitch, AtomInput, AtomSelect },
  props: {
    column: {
      type: Array,
      required: true,
    },
    policy: {
      type: String,
      required: true,
    },
    unitList: {
      type: Array,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    index: {
      type: Number,
      required: true,
    },
    isClickApply: {
      type: Boolean,
      required: false,
      default: false,
    },
    isValidateTrigger: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  emits: ["error"],
  data() {
    return {
      errorMessage: "",
      isError: false,
      selectedUnit: "",
      isShowError: false,
    }
  },
  computed: {
    row: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    unit() {
      return this.unitList.map((item) => {
        return item.name
      })
    },
  },
  watch: {
    row: {
      deep: true,
      handler() {
        if (this.isClickApply || this.isValidateTrigger) {
          this.valueErrorCheck(this.row)
        }
        this.checkInvalidValueInDisableRow(this.row)
      },
    },
    isClickApply() {
      this.valueErrorCheck(this.row)
      this.isShowError = this.isClickApply
    },
    isValidateTrigger() {
      this.valueErrorCheck(this.row)
      this.isShowError = this.isValidateTrigger
    },
  },
  methods: {
    valueErrorCheck(value) {
      if (value.isEnabled) {
        if (!value.warning || !value.critical || !value.unit.id) {
          this.isError = true
          if (!value.warning || !value.critical) {
            this.errorMessage = "Please enter warning and critical threshold"
          } else {
            this.errorMessage = "Please enter unit"
          }
          this.$emit("error", this.isError, this.index)
        }
        // resource is not storage check warning > critical
        else if (
          value.resource !== "Storage" &&
          Number(value.warning) > Number(value.critical)
        ) {
          this.isError = true
          this.errorMessage = "Please enter valid thresholds"
          this.$emit("error", this.isError, this.index)
        }

        // resource is storage check warning < critical
        else if (
          value.resource === "Storage" &&
          Number(value.warning) < Number(value.critical)
        ) {
          this.isError = true
          this.errorMessage = "Please enter valid thresholds"
          this.$emit("error", this.isError, this.index)
        }
        // [warning, critical] < 1
        else if (Number(value.warning) < 1 || Number(value.critical) < 1) {
          this.isError = true
          this.errorMessage = "Please enter valid thresholds"
          this.$emit("error", this.isError, this.index)
          // [warning, critical] is not number
        } else if (
          !this.isValidNumber(value.critical) ||
          !this.isValidNumber(value.warning)
        ) {
          this.isError = true
          this.errorMessage = "Please enter valid thresholds"
          this.$emit("error", this.isError, this.index)
        }
        // unit = percent && [warning, critical] > 100
        else if (
          value.unit.name === "Percent" &&
          (Number(value.warning) > 100 || Number(value.critical) > 100)
        ) {
          this.isError = true
          this.errorMessage = "Please enter valid thresholds"
          this.$emit("error", this.isError, this.index)
        }
        // no error
        else {
          this.errorMessage = ""
          this.isError = false
          this.$emit("error", this.isError, this.index)
        }
      } else this.$emit("error", false, this.index)
    },
    changeSelected(event) {
      for (let i = 0; i < this.unitList.length; i++) {
        if (event === this.unitList[i].name) {
          this.row.unit = {
            id: this.unitList[i].id,
            name: this.unitList[i].name,
          }
        }
      }
    },
    checkInvalidValueInDisableRow(value) {
      if (!value.isEnabled) {
        if (
          !value.warning ||
          !value.critical ||
          !value.unit.id ||
          !this.isValidNumber(value.critical) ||
          !this.isValidNumber(value.warning) ||
          Number(value.warning) > Number(value.critical) ||
          Number(value.warning) < 1 ||
          Number(value.critical) < 1 ||
          (value.unit.name === "Percent" &&
            (Number(value.warning) > 100 || Number(value.critical) > 100))
        ) {
          this.setDefaultValueToInvalidRow()
        }
      }
    },
    setDefaultValueToInvalidRow() {
      this.row.critical = ""
      this.row.warning = ""
      this.row.unit.id = ""
      this.row.unit.name = ""
    },
    isValidNumber(input) {
      if (input === null) return false
      const regex = /^[+-]?\d+(\.\d+)?$/
      return regex.test(input)
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0;
}

.molecule-list-resource_row {
  background: #ffffff;
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  width: 100%;
  padding: 30px 15px;
  position: relative;
}

// resource
.row__resource {
  display: flex;
  align-items: center;
  width: 100%;
}
.resource__label {
  font-size: 14px;
  font-weight: 500;
  color: #5e5873;
}
.resource__label--disable {
  color: #b9b9c3;
}
.basic__resource {
  color: #7367f0;
}

// container
.row__container {
  display: flex;
  width: 100%;
  padding-top: 10px;
}
.row__container--center {
  align-items: center;
}
.row__container--top {
  align-items: flex-start;
}

// sub-container
.row__sub-container {
  width: 100%;
}

// warning
.row__warning {
  display: flex;
  align-items: center;
  width: 27%;
  padding-right: 10px;
}

// critical
.row__critical {
  display: flex;
  align-items: center;
  width: 27%;
  padding-right: 10px;
}

// unit
.row__unit {
  display: flex;
  align-items: center;
  width: 46%;
}
.unit__select {
  width: 100%;
}

// title
.row__title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  height: 40px;
  //text-align: center;
}

.row__label {
  color: #5e5873;
  font-size: 12px;
  //text-align: center;
}

// error
.row_error {
  color: #ea5455;
  font-size: 12px;
  position: absolute;
  bottom: 5px;
}

.form-group {
  margin-bottom: 0;
}

.text-center {
  text-align: center;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .molecule-list-resource_row {
    display: flex;
    align-items: center;
    height: 82px;
    padding: 15px 15px;
  }
  .row__resource {
    display: flex;
    align-items: center;
    padding-left: 30px;
    padding-right: 0;
    width: 30%;
  }

  // container
  .row__container {
    width: 70%;
    padding-top: 0;
  }
  .row__warning {
    display: flex;
    align-items: center;
    width: 30%;
    padding-left: 15px;
    padding-right: 0;
  }
  .row__critical {
    display: flex;
    align-items: center;
    width: 30%;
    padding-left: 15px;
    padding-right: 0;
  }
  .row__unit {
    display: flex;
    align-items: center;
    width: 40%;
    padding-left: 15px;
  }
  .unit__select {
    width: 100%;
  }

  // title
  .row__title {
    display: none;
  }

  // error
  .row_error {
    left: 30%;
    padding-left: 20px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
